import { render, staticRenderFns } from "./Addarticle.vue?vue&type=template&id=206de67e&scoped=true&"
import script from "./Addarticle.vue?vue&type=script&lang=js&"
export * from "./Addarticle.vue?vue&type=script&lang=js&"
import style0 from "./Addarticle.vue?vue&type=style&index=0&id=206de67e&lang=scss&scoped=true&"
import style1 from "./Addarticle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206de67e",
  null
  
)

export default component.exports